import { RingLoader } from "components/lib/npm";

const Loader = ({ size = 25, color = "#fa8c16" }) => {
    return (
        <div className="loader_sec">
            <RingLoader className='loader' color={color} size={`${size}px`} />
        </div>)
}

export default Loader